Vue.directive('loading', {
    bind(el, binding, vNode){
        if(binding.value){
            let status = true;
            el.style.position = 'relative';
            for (let index = 0; index < el.children.length; index++) {
                if(el.children[index].className == 'ldc-loading'){
                    status = false;
                    return;
                }
            }
            if(status){
                el.insertAdjacentHTML('beforeend', divLoading);
            }
        }
    },
    update(el,binding, vNode){
        if(binding.value){
            let status = true;
            el.style.position = 'relative';
            for (let index = 0; index < el.children.length; index++) {
                if(el.children[index].className == 'ldc-loading'){
                    status = false;
                    return;
                }
            }
            if(status){
                el.insertAdjacentHTML('beforeend', divLoading);
            }
            
        }else{
            for (let index = 0; index < el.children.length; index++) {
                if(el.children[index].className == 'ldc-loading'){
                    el.children[index].remove();
                    el.removeAttribute("style");
                }
            }
        }
    }
});

let divLoading = `<div class="ldc-loading">
                    <div class="ldc-loading-spinner">
                        <svg viewBox="25 25 50 50" class="ldc-circular">
                            <circle cx="50" cy="50" r="20" fill="none" class="ldc-path"></circle>
                        </svg>
                    </div>
                </div>`;